import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { ForceUpdateStateService } from '@app/shared/services/force-update-state.service';
import { catchError, throwError } from 'rxjs';

export const forceUpdateInterceptor: HttpInterceptorFn = (req, next) => {
  const state = inject(ForceUpdateStateService);
  const router = inject(Router);
  const zone = inject(NgZone);

  return next(req).pipe(
    catchError((error) => {
      if (error instanceof HttpErrorResponse && state.isForceUpdateError(error)) {
        state.setFromHttpError(error);

        const currentUrl = router.url || '';
        if (!currentUrl.startsWith('/force-update')) {
          zone.run(() => {
            void router.navigateByUrl('/force-update', { replaceUrl: true });
          });
        }
      }
      return throwError(() => error);
    }),
  );
};
